import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';
import {ProvidersIdsEnum} from '../../../../../../../../util/type';

export const abuseFormId = 'new-abuse-form';

export enum AbuseFormItemEnum {
    Choices = 'choices',
    Description = 'description',
}

export const abuseReasons: Array<{title: LangKeyType; id: number}> = [
    {title: 'REVIEWS__COMPLAINT_POPUP__2GIS__NO_CLIENT', id: 1},
    {title: 'REVIEWS__COMPLAINT_POPUP__OFFENSIVE_CONTENT', id: 2},
    {title: 'REVIEWS__COMPLAINT_POPUP__MENTION_COMPETITOR', id: 3},
    {title: 'REVIEWS__COMPLAINT_POPUP__NOT_APPLY_THIS_COMPANY', id: 4},
    {title: 'REVIEWS__COMPLAINT_POPUP__PRIVACY_VIOLATION', id: 5},
];

// Google's own "Report review" reasons (single-select). `code` is the backend category value
// sent as the abuse `reason` (see backend google_com.review_abuse.reasons.GoogleReportReason).
export const googleAbuseReasons: Array<{title: LangKeyType; id: number; code: string}> = [
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__OFF_TOPIC', id: 1, code: 'off_topic'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__SPAM', id: 2, code: 'spam'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__CONFLICT_OF_INTEREST', id: 3, code: 'conflict_of_interest'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__PROFANITY', id: 4, code: 'profanity'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__HARMFUL', id: 5, code: 'harmful'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__BULLYING', id: 6, code: 'bullying_or_harassment'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__HATE_SPEECH', id: 7, code: 'discrimination_or_hate_speech'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__PERSONAL_INFORMATION', id: 8, code: 'personal_information'},
    {title: 'REVIEWS__COMPLAINT_POPUP__GOOGLE__NOT_HELPFUL', id: 9, code: 'not_helpful'},
];

export function isGoogleCatalog(catalogId?: number | null): boolean {
    return (
        catalogId === ProvidersIdsEnum.google ||
        catalogId === ProvidersIdsEnum.googleMaps ||
        catalogId === ProvidersIdsEnum.googleMapsNew
    );
}

// The Report button is available for a non-deleted review when the backend allows it, or — when the
// Google Playwright complaint flow is enabled — for any Google review regardless of `ableToAbuse`.
export function isAbuseAvailable(parameters: {
    isDeleted: boolean;
    ableToAbuse: boolean;
    catalogId?: number | null;
    googlePlaywrightEnabled: boolean;
}): boolean {
    return (
        !parameters.isDeleted &&
        (parameters.ableToAbuse || (parameters.googlePlaywrightEnabled && isGoogleCatalog(parameters.catalogId)))
    );
}
